export default "__VITE_ASSET__DavyMM72__"